import { useBrokerDetailsStore } from '../../state/brokerDetailsStore';

export const useBrokerAccountSetupFormHandlers = () => {
    const handleClientFeeTypeChange = (value: string) => {
        if (value === '' || value === '.') {
            useBrokerDetailsStore.getState().updateFields({ clientFeeType: value });
            return;
        }
        const numericValue: number = Number(value);
        if (isNaN(numericValue)) return;
        if (numericValue > 1 || numericValue < 0) return;
        useBrokerDetailsStore.getState().updateFields({ clientFeeType: value });
    };

    return { handleClientFeeTypeChange };
};
